import { BaseService } from './base.service';
import { IHomeParameter } from '../models/home';
import { Uris } from '../common/constants';
export interface IHomeService {

  getStatisticData<T>(type: "tickets" | "team-members" | "block" | "contractor" | "service-book", param: IHomeParameter): Promise<T>

}
export class HomeService extends BaseService implements IHomeService {

  getStatisticData<T>(type: "tickets" | "team-members" | "block" | "contractor" | "service-book", param: IHomeParameter): Promise<T> {
    return super.get(Uris.Home, Object.assign({}, param, { type: type }))
      .then(res => {
        return Promise.resolve(res as any);
      })
      .catch(err => {
        return Promise.reject(err);
      })
  }

  /**
   *
   */
  constructor() {
    super()
  }
}


// WEBPACK FOOTER //
// ./src/services/home.service.ts